import React from 'react';
import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';
import closeIcon from '../../assets/closeIcon.svg';

const Img = styled.img`
  height: 24px;
  width: fit-content;
  margin: 24px;
  cursor: pointer;
`;

const IFrame = styled.iframe`
  height: 100vh;
`;

export const TermsOfServicePopUp = ({ open, handleClose }: { open: boolean; handleClose: () => void }) => {
  return (
    <Dialog fullScreen={true} open={open}>
      <Img src={closeIcon} onClick={handleClose} />
      <IFrame src={`${process.env.REACT_APP_WEBSITE}/terms-of-use`} title="terms of use" />
    </Dialog>
  );
};
